let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1h7l1")).then(() => parcelRequire('cyKAC'));